import React from "react";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaShoppingCart,
  FaCogs,
  FaDatabase,
  FaTools,
} from "react-icons/fa";

const services = {
  "Website Development": {
    icon: <FaLaptopCode className="text-2xl" />,
    items: [
      "Custom Website Development",
      "Responsive Design",
      "Database Design & API Integration",
    ],
  },
  "App Development": {
    icon: <FaMobileAlt className="text-xl" />,
    items: [
      "Mobile App Development",
      "Cross-Platform App Development",
      "Mobile App Maintenance",
    ],
  },
  "E-commerce Development": {
    icon: <FaShoppingCart className="text-xl" />,
    items: [
      "E-commerce Development",
      "Payment Gateway Integration",
      "Inventory Management",
      "E-commerce Analytics",
    ],
  },
  "Software Development": {
    icon: <FaCogs className="text-xl" />,
    items: [
      "Custom Software Development",
      "SaaS Product Development",
      "API Development & Integration",
    ],
  },
  "API & Backend Development": {
    icon: <FaDatabase className="text-xl " />,
    items: [
      "Custom API",
      "Backend Architecture",
      "Database Management",
      "Third-Party API Integration",
    ],
  },
  "Support & Maintenance": {
    icon: <FaTools className="text-xl " />,
    items: [
      "Software Support",
      "Troubleshooting",
      "Regular Maintenance",
      "Feature Integration",
      "Technical Documentation",
    ],
  },
};
const Services = () => {
  return (
    <section className="pt-5 pb-10">
      <div className="mx-auto max-w-6xl px-5 lg:p-0 ">
        <div className="text-center">
          <div className="divider text-xl py-5">
            <h1 className="mx-auto text-4xl font-bold my-3">Our Services</h1>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
          {Object.entries(services).map(([category, { icon, items }], idx) => (
            <div
              key={idx}
              className="bg-base-200 p-4 rounded-lg shadow-md hover:shadow-xl transition"
            >
              <div className="flex items-center gap-2 mb-4">
                {icon}
                <h3 className="text-xl font-semibold">{category}</h3>
              </div>
              <ol className="list-disc list-inside space-y-1 pl-4">
                {items.map((item, index) => (
                  <li key={index} className="text-gray-400">
                    {item}
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
